import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DefaultBook from "../Images/defaultBook.png";
import { FavGotoTopButton } from "./FavGotoTopButton";

interface BookListButtonProps {
  books: any;
  type: "kalyan" | "kalpatru" | "geetgovind" | "book" | "vivek";
  title: string;
  getBook: (value: any) => void;
}

export const FavouriteBooks: React.FC<BookListButtonProps> = ({
  books,
  type,
  title,
  getBook,
}) => {
  const [displayCount, setDisplayCount] = useState(4);
  const { t } = useTranslation();

  const showMoreBooks = () => {
    setDisplayCount(books?.length); // Increase by a certain number
  };

  const showLessBooks = () => {
    setDisplayCount(4); // Reset to initial display count
  };

  const getValueType = (type: any, book: any) => {
    let imgpath = "";
    switch (type) {
      case "book":
        imgpath = book.bookThumbPath ?? DefaultBook;
        break;
      case "kalyan":
        imgpath = book.kalyanThumbPath ?? DefaultBook;
        break;
      case "kalpatru":
        imgpath = book.kalyanKalpataruThumbPath ?? DefaultBook;
        break;
      case "geetgovind":
        imgpath = book.monthlyMagazineThumbPath ?? DefaultBook;
        break;
      case "vivek":
        imgpath = book.vivekVaniThumbPath ?? DefaultBook;
        break;
      default:
        imgpath = DefaultBook;
    }
    return imgpath;
  };

  return (
    <div>
      {books?.length > 0 ? (
        <div>
          <div>
            <p
              style={{
                fontFamily: "ChanakyaUni",
                fontWeight: 700,
                fontStyle: "normal",
                color: "#b42a38",
                fontSize: "26px",
                margin: "0 0 10px",
              }}
            >
              {title}
            </p>
            <div className="row" style={{ marginBottom: "21px", padding: "0 15px" }}>
              {books.slice(0, displayCount).map((book: any) => (
                <div className="col-3" style={{ marginTop: "15px" }}>
                  <div
                    className="favebooks"
                    key={`related-${book.id}`}
                    onClick={() => {
                      getBook(book);
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <div>
                        <img
                          style={{
                            cursor: "pointer",
                            borderRadius: "5px",
                          }}
                          className="imgcenter"
                          src={getValueType(type, book)}
                          onError={(e) => {
                            e.currentTarget.src = DefaultBook;
                          }}
                          alt={book.name}
                          title={book.name}
                          width="117"
                          height="165"
                        />
                        <p>
                          {book?.name?.length > 40
                            ? book?.name.slice(0, 40) + "..."
                            : book?.name}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="fav-section-actions">
            {books?.length > 4 &&
              (displayCount < books?.length ? (
                <button className="favitems" onClick={showMoreBooks}>
                  {t("SeeAll_tr")}
                </button>
              ) : (
                <button className="favitems" onClick={showLessBooks}>
                  {t("show_less_tr")}
                </button>
              ))}
            <FavGotoTopButton />
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}; 